<template>
    <div>
        <BaseMeetingCard ref="baseMeetingCardRef">
            <template #badges>
                <SchedulingStateBadge
                    :entityWithSchedulingState="localBookingData"
                />
                <BadgeSeparator />
                <template v-if="localBookingPayment">
                    <PaymentStateBadge
                        :entityWithPaymentState="
                            localBookingData.getSingleExistingReservationData()
                        "
                    />
                    <BadgeSeparator />
                </template>
                <RecurringMeetingsCountBadge
                    :numberOfScheduledMeetings="
                        localBookingData.booking.numberOfScheduledMeetings
                    "
                />
            </template>

            <template #visibleDetails>
                <RecurringMeetingBasicDetailsSection
                    :bookingData="localBookingData"
                    :isCardExpanded="baseMeetingCardRef?.isExpanded ?? false"
                    :displayTimezone="displayTimezone"
                />
            </template>

            <template #hiddenDetails>
                <RecurringMeetingExtraDetailsSection
                    v-if="baseMeetingCardRef?.isExpanded ?? false"
                    :bookingData="localBookingData"
                    @onBookingRefunded="
                        handleBookingUpdated($event.bookingData)
                    "
                />
            </template>
        </BaseMeetingCard>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import BookingData from '@/App/Booking/Booking/Entity/BookingData'
    import RecurringMeetingsCountBadge from '@/App/Booking/Recurring/Component/RecurringMeetingsCountBadge.vue'
    import RecurringMeetingBasicDetailsSection from '@/App/Booking/Recurring/Component/RecurringMeetingBasicDetailsSection.vue'
    import RecurringMeetingExtraDetailsSection from '@/App/Booking/Recurring/Component/RecurringMeetingExtraDetailsSection.vue'
    import PaymentStateBadge from '@/App/Booking/Meeting/Component/PaymentStateBadge.vue'
    import SchedulingStateBadge from '@/App/Booking/Meeting/Component/SchedulingStateBadge.vue'
    import BadgeSeparator from '@/App/Booking/Meeting/Component/BadgeSeparator.vue'
    import BaseMeetingCard from '@/App/Booking/Meeting/Component/BaseMeetingCard.vue'
    import type { BaseMeetingCardRefType } from '@/Shared/AutoGenerated/Types'
    import type { TimeZoneEnum } from '@/Shared/AutoGenerated/TimeZoneEnum'

    const props = defineProps({
        bookingData: {
            type: Object as PropType<BookingData>,
            required: true,
        },
        displayTimezone: {
            type: String as PropType<TimeZoneEnum>,
            required: true,
        },
    })

    const baseMeetingCardRef = ref<BaseMeetingCardRefType>(null)
    const localBookingData = ref<BookingData>(props.bookingData)
    const localBookingPayment =
        localBookingData.value.getSingleExistingReservationData().bookingPayment

    const handleBookingUpdated = (updatedBookingData: BookingData): void => {
        localBookingData.value = updatedBookingData
    }
</script>
